import { render } from "./MobileDefault.vue?vue&type=template&id=fd590650&scoped=true"
import script from "./MobileDefault.vue?vue&type=script&lang=js"
export * from "./MobileDefault.vue?vue&type=script&lang=js"

import "./MobileDefault.vue?vue&type=style&index=0&id=fd590650&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd590650"]])

export default __exports__